import React, { useState } from "react";
import { useDrag } from "react-dnd";
import { Box, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { openPopup } from "../../stateManagement/actions/popupActions";

const DraggableWidget = React.memo(({
  widget,
  formId,
  widgetTemplate,
  isSelected,
  onClick,
  onRemove,
  updateConfig,
  index,
  isMandatory = false, 
}: any) => {

  const [{ isDragging }, dragRef] = useDrag({
    type: "WIDGET",
    item: {
      widget,
      fromFormId: formId,
      index,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    const isRequired =
      isMandatory ||
      widget?.config?.required;
    if (isRequired) {
      openPopup("Alert", "This widget is mandatory and cannot be removed.");
    } else {
      onRemove(widget.id);
    }
  };
  

  return (
    <>
      <Box
        ref={dragRef}
        sx={{
          width: "100%",
          padding: "8px",
          backgroundColor: isSelected ? "#e0f7fa" : "#ffffff",
          border: "1px solid #ddd",
          borderRadius: "4px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "8px",
          cursor: "pointer",
          opacity: isDragging ? 0.5 : 1,
          position: "relative",
          "&:hover": { backgroundColor: "#f1f1f1" },
        }}
        onClick={() => onClick(widget.id)}
      >
        {widgetTemplate.component({
          ...widget.config,
          id: widget.id,
          config: widget.config,
          updateConfig,
          selected: isSelected,
          checked: widget.config.value,
          onChange: (newValue: any) => {
            updateConfig(widget.id, { ...widget.config, value: newValue });
          },
        })}

        <IconButton
          onClick={handleDeleteClick}
          sx={{
            position: "absolute",
            top: "-8px",
            right: "-8px",
            backgroundColor: "white",
            border: "1px solid #ddd",
            width: "18px",
            height: "18px",
            fontSize: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "50%",
            "&:hover": { backgroundColor: "#ffebee" },
          }}
        >
          ❌
        </IconButton>
      </Box>
    </>
  );
});

export default DraggableWidget;
